import Vue from 'vue';
import Component from 'vue-class-component';
import {MenuItem} from '../model/menu-item';
import {Prop} from 'vue-property-decorator';
import {AuthorisationManager, Identity, Icon} from 'wc-lib';
import {Service} from '../service';

require('../../node_modules/wc-lib/icons/search1.svg');
require('../../icons/tick.svg');
require('../../icons/view.svg');

@Component({
  template: require('./set-participant.html'),
  components: {
    'wc-icon': Icon
  }
})
export class SetParticipant extends Vue {
  participants: Array<any> = [];
  searchString: string = "";
  currentParticipant: string = "";
  originalParticipantId: string = "";
  originalParticipantName: string = "";

  async mounted() {
    let tokenString = localStorage.getItem('aemo-session');
    if (tokenString !== undefined && tokenString !== '') {
      let token = JSON.parse(tokenString);
      this.originalParticipantId = token.PrimaryParticipantId;
      this.originalParticipantName = token.PrimaryParticipantName;
    }
    this.currentParticipant = AuthorisationManager.getParticipant();
    let response = await Service.getParticipants();
    this.participants = response.data.participantList;
  }

  get searchParticipants(): Array<any> {
    let searchString = this.searchString.toLowerCase();
      return this.participants.filter(x => x.participantID.toLowerCase().includes(searchString) || x.participantName.toLowerCase().includes(searchString) ||
          x.market.toLowerCase().includes(searchString));
  }

  get actingParticipantId(): string {
    return AuthorisationManager.getParticipant();
  }

  async setParticipant(participantId: string, participantName: string) {
    let originalParticipantId = AuthorisationManager.getParticipant();
    let originalParticipantName = AuthorisationManager.getParticipantName();

    AuthorisationManager.setParticipant(participantId, participantName);

    let response = await Service.setParticipant(participantId);
    if (!response.result) {
      AuthorisationManager.setParticipant(originalParticipantId, originalParticipantName);
      //Notification.error('Failed setting participant, please try again');
    } else {
      this.currentParticipant = participantId;
    }
  }
}




// WEBPACK FOOTER //
// src/views/set-participant.ts